import '../styles/summary-report.css';

export type RichSummary = {
  html?: string;
};

type RichSummaryReportProps = {
  summary?: RichSummary | null;
  className?: string;
};

export function RichSummaryReport({ summary, className = '' }: RichSummaryReportProps) {
  if (!summary?.html) return null;

  return <div className={className} dangerouslySetInnerHTML={{ __html: summary.html }} />;
}
